<template>
  <div class="appBlock">
    <div
      class="steps"
      v-show="!prew_history"
    >
      <a-drawer
        :title="$t('Preview')"
        placement="left"
        width="60%"
        @close="visiblePreview = false"
        :visible="visiblePreview"
      >
        <invoicePreview
          :statusTag="statusList.find((x) => x.name == previewElement.status)"
          :MY_COMPANY_LIST="MY_COMPANY_LIST"
          :COMPANY_LIST="COMPANY_LIST"
          :USER_LIST="USER_LIST"
          :DEAL_LIST="element.alldeal"
          :document="previewElement"
          :defaultResponsible="form_info.defaultResponsible"
        />
      </a-drawer>

      <a-steps
        :current="current"
        size="small"
      >
        <a-step
          v-for="(item, index) in statusList"
          :key="index"
          :title="
            index < current
              ? $t('Completed')
              : index == current
              ? $t('Running')
              : $t('Awaiting')
          "
          :description="$t(stepList[index])"
        />
      </a-steps>
    </div>
    <div
      class="mainBlock--btn"
      v-show="!prew_history"
      style="margin-bottom: 20px"
    >
      <a-row>
        <a-col :span="10">
          <a-button-group>
            <a-button @click="handleHistoryFile">
              <a-icon type="history" />
              {{ $t("History") }}
            </a-button>
            <a-button
              icon="eye"
              @click="preview"
            >{{ $t("Preview") }}</a-button>
            <a-button
              @click="myPrint"
              type="primary"
              icon="printer"
            >
              {{ $t("Print") }}
            </a-button>
            <a-button
              type="primary"
              :href="element.url"
              icon="download"
            >
              {{ $t("Download") }}
            </a-button>
          </a-button-group>
        </a-col>
        <a-col
          :span="6"
          style="text-align: center"
        >
          <div
            v-if="currentEdit"
            style="display: flex; align-items: center; justify-content: center"
          >
            <a-statistic-countdown
              :value="deadline"
              @finish="() => this.handlerBack({})"
              format="mm:ss"
              style="margin-right: 10px"
            />
            <a-tooltip :title="$t('Time until the end of the session')">
              <a-icon type="info-circle" />
            </a-tooltip>
          </div>
          <span v-else>{{
            $t("This file is edited by") +
            " " +
            getUser(element.currentlyeditor)
          }}</span>
        </a-col>
        <a-col
          :span="8"
          style="text-align: right"
        >
          <a-button
            v-if="profile.ADMIN && current < 6"
            @click="() => handleSubmitStep(false)"
            style="margin-right: 25px"
            icon="save"
          />
          <a-button-group style="margin-right: 25px">
            <a-button
              v-if="current > 0 && current < 6 && profile.ADMIN"
              @click="ReturnToStepBack"
              type="primary"
            >
              <a-icon type="left" />
              {{ current == 2 || current == 3 ? $t("Reject") : $t("Back") }}
            </a-button>
            <a-button
              @click="() => handleSubmitStep()"
              type="primary"
              :disabled="isSaveDisabled || disableFromResponsible"
              v-if="current <= 5"
            >
              {{ current == 2 || current == 3 ? $t("Akceptuj") : $t("Save") }}
              <a-icon type="right" />
            </a-button>
          </a-button-group>
          <a-button
            type="danger"
            icon="close"
            @click="() => showBackModalConfirm(false)"
          />
        </a-col>
      </a-row>
    </div>
    <a-spin
      :spinning="spinning"
      size="large"
    >
      <div style="border: 1px solid lightgray; border-radius: 5px">
        <template>
          <div
            class="mainBlock--form"
            v-show="!prew_history"
          >
            <div class="Form">
              <a-spin
                :spinning="prew_doc_spinner"
                style="width: 60%"
                v-if="current != 1"
              >
                <template v-if="!prew_doc || element.base64file">

                  <div v-if="!prew_doc">
                    <div
                      v-if="docPdf"
                      style="position: relative; margin: 15px"
                    >
                      <canvas
                        id="pdf-canvas-step"
                        class="pdf-canvas"
                      ></canvas>
                      <div
                        id="text-layer-step"
                        class="text-layer"
                      ></div>
                      <div
                        v-if="!prew_doc_spinner"
                        style="display: flex; justify-content: space-between"
                      >
                        <a-button
                          :disabled="currentPage - 1 < 1 ? true : false"
                          @click="
                            () => {
                              currentPage--;
                              getpdf();
                            }
                          "
                        >
                          <a-icon type="left" />
                          {{ $t("Prev") }}
                        </a-button>
                        <span>{{ currentPage }} / {{ countPages }}</span>
                        <a-button
                          :disabled="currentPage + 1 > countPages ? true : false"
                          @click="
                            () => {
                              currentPage++;
                              getpdf();
                            }
                          "
                        >
                          {{ $t("Next") }}
                          <a-icon type="right" />
                        </a-button>
                      </div>
                    </div>

                    <div  v-else style="width: 100%">
                      <img :src="`${element.DOWNLOAD_URL != undefined
                          ? element.DOWNLOAD_URL
                          : element.url
                        }`" style="width: 100%"  />
                    </div>
                  </div>
                  <div v-else-if="element.base64file">          
                      <img :src="`data:image/jpeg;base64,${element.base64file}`" style="width: 100%"  />
                  </div>

                </template>

              <div v-else>
                <a-empty />
              </div>

              </a-spin>
              <div style="width: 40%">
                <firstStep
                  v-if="current == 0"
                  :bounds="bounds"
                  :table="table"
                  :statusTag="statusTag"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :COMPANY_LIST="COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  :disabled="false"
                  :disableFromResponsible="disableFromResponsible"
                  :document="element"
                  :profile="profile"
                  :key_words="key_words"
                  :currentEdit="currentEdit"
                  :info="form_info"
                  :user_setup="user_setup"
                  ref="firstStep"
                  @showPreview="showPreview"
                  @onback="handlerBack"
                  @changeSpinning="changeSpinning"
                />
                <thirdStep
                  v-if="current == 2"
                  :statusTag="statusTag"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :COMPANY_LIST="COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  :disableFromResponsible="disableFromResponsible"
                  :document="element"
                  :info="form_info"
                  :profile="profile"
                  :user_setup="user_setup"
                  :key_words="key_words"
                  ref="thirdStep"
                  @showPreview="showPreview"
                  @onback="handlerBack"
                  @changeSpinning="changeSpinning"
                />
                <fourthStep
                  v-if="current == 3"
                  :statusTag="statusTag"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :COMPANY_LIST="COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  :document="element"
                  :profile="profile"
                  :key_words="key_words"
                  :user_setup="user_setup"
                  :info="form_info"
                  ref="fourthStep"
                  @showPreview="showPreview"
                  @onback="handlerBack"
                  @changeSpinning="changeSpinning"
                />
                <fifthStep
                  v-if="current == 4"
                  :statusTag="statusTag"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :COMPANY_LIST="COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  :document="element"
                  :disableFromResponsible="disableFromResponsible"
                  :profile="profile"
                  :key_words="key_words"
                  :user_setup="user_setup"
                  :info="form_info"
                  ref="fifthStep"
                  @handlerSaveDisabled="handlerSaveDisabled"
                  @showPreview="showPreview"
                  @onback="handlerBack"
                  @changeSpinning="changeSpinning"
                />
                <sixthStep
                  v-if="current == 5 || current == 6"
                  :statusTag="statusTag"
                  :currentSix="current"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :COMPANY_LIST="COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  :document="element"
                  :profile="profile"
                  :info="form_info"
                  ref="sixthStep"
                  @showPreview="showPreview"
                  @onback="handlerBack"
                  @changeSpinning="changeSpinning"
                />
              </div>
            </div>
            <a-table
              v-if="![1].includes(current)"
              :columns="DescInvoiceColumns"
              :data-source="element.invoiceTable"
              style="padding: 25px"
              tableLayout="auto"
              :scroll="{ x: true }"
              :pagination="{ hideOnSinglePage: true }"
              bordered
            >
              <template
                slot="namefield"
                slot-scope="text, record"
              >
                <a-auto-complete
                  :data-source="title_options"
                  v-if="record.editable && current == 0"
                  style="margin: -5px 0; width: 100%"
                  v-model="record['namefield']"
                  @change="
                    (e) => handleChangeDescInvoice(e, record.key, 'namefield')
                  "
                />
                <template v-else>{{ text }}</template>
              </template>
               <template
                slot="unitPrice"
                slot-scope="text, record"
              >
                <a-input
                  v-if="record.editable && current == 0"
                  style="margin: -5px 0"
                  v-model="record['unitPrice']"
                  @change="
                    (e) => handleChangeDescInvoice(e.target.value, record.key, 'unitPrice')
                  "
                />
                <template v-else>{{ text }}</template>
              </template>
              <template
                slot="quantity"
                slot-scope="text, record"
              >
                <a-input-number
                  v-if="record.editable && current == 0"
                  v-model="record['quantity']"
                  :min="1"
                  @change="(e) => handleChangeDescInvoice(e, record.key, 'quantity')"
                  style="margin: -5px 0"
                />
                <template v-else>{{ text }}</template>
              </template>
              <template
                slot="koszty"
                slot-scope="text, record"
              >
                <a-auto-complete
                  :data-source="costs_options"
                  v-if="record.editable && current == 0"
                  style="margin: -5px 0"
                  v-model="record['koszty']"
                  @change="
                    (e) => handleChangeDescInvoice(e, record.key, 'koszty')
                  "
                />
                <template v-else>{{ text }}</template>
              </template>
              <template
                slot="vat"
                slot-scope="text, record"
              >
                <div :key="col">
                  <a-select
                    v-if="record.editable && current == 0"
                    style="margin: -5px 0; width: 100%"
                    v-model="record['vat']"
                    @change="
                      (e) => handleChangeDescInvoice(e, record.key, 'vat')
                    "
                  >
                    <a-select-option
                      v-for="(item, index) in vat_options"
                      :key="index"
                    >{{ index }}</a-select-option>
                  </a-select>
                  <template v-else>{{ text }}</template>
                </div>
              </template>
              <template
                slot="operation"
                slot-scope="text, record"
              >
                <div
                  class="editable-row-operations"
                  v-if="current == 0 && !disableFromResponsible"
                >
                  <span v-if="record.editable">
                    <a
                      :disabled="!record.namefield || !record.unitPrice"
                      @click="() => saveDescInvoice(record.key)"
                      style="margin-right: 10px"
                    >
                      <a-icon type="save" />
                    </a>

                    <a @click="() => cancelDescInvoice(record.key)">
                      <a-icon type="stop" />
                    </a>
                  </span>
                  <span v-else>
                    <a
                      style="margin-right: 10px"
                      :disabled="DescInvoiceEditingKey !== ''"
                      @click="() => editDescInvoice(record.key)"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      v-if="element.invoiceTable.length"
                      :disabled="DescInvoiceEditingKey !== ''"
                      @click="() => onDeleteDescInvoice(record.key)"
                    >
                      <a-icon type="delete" />
                    </a>
                  </span>
              </template>


              <template slot="footer">
                <a-button
                  type="primary"
                  class="editable-add-btn"
                  @click="handleAddDescInvoice"
                  v-if="current == 0 && !disableFromResponsible"
                >{{ $t("Add") }}</a-button>
              </template>
            </a-table>
            <secondStep
              v-if="[1, 2, 3, 4, 5, 6].includes(current)"
              :bounds="bounds"
              :profile="profile"
              :info="form_info"
              :user_setup="user_setup"
              :key_words="key_words"
              :current="current"
              :statusTag="statusTag"
              :COMPANY_LIST="COMPANY_LIST"
              :MY_COMPANY_LIST="MY_COMPANY_LIST"
              :USER_LIST="USER_LIST"
              :disableFromResponsible="disableFromResponsible"
              :document="element"
              :defaultResponsible="form_info.defaultResponsible"
              @onback="handlerBack"
              @showPreview="showPreview"
              @changeSpinning="changeSpinning"
              @handlerSaveDisabled="handlerSaveDisabled"
              ref="secondStep"
            />
            <template v-if="current != 1">
              <a-list
                id="my_comments_styl"
                v-if="comments.length != 0"
                :dataSource="comments"
                :header="`${comments.length} ${
                  comments.length > 1 ? $t('records') : $t('record')
                }`"
                itemLayout="horizontal"
                style="padding: 0 25px"
              >
                <a-list-item
                  slot="renderItem"
                  slot-scope="item"
                >
                  <a-comment
                    :author="item.FIO"
                    :content="item.content"
                    :datetime="item.datetime"
                  >
                    <a-avatar
                      slot="avatar"
                      :src="
                        item.photo == ''
                          ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                          : item.photo
                      "
                      :alt="profile.NAME + ' ' + profile.LAST_NAME"
                    />
                  </a-comment>
                </a-list-item>
              </a-list>

              <a-comment style="padding: 0 25px">
                <a-avatar
                  slot="avatar"
                  :src="
                    profile.PERSONAL_PHOTO == null
                      ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                      : profile.PERSONAL_PHOTO
                  "
                  :alt="profile.NAME + ' ' + profile.LAST_NAME"
                />
                <div slot="content">
                  <a-form-item>
                    <a-textarea
                      :rows="2"
                      @change="handleChangeComment"
                      :value="valueComment"
                    ></a-textarea>
                  </a-form-item>
                  <a-form-item style="padding-bottom: 10px">
                    <a-button
                      htmlType="submit"
                      :disabled="submittingComment"
                      :loading="submittingComment"
                      @click="handleSubmitComment"
                      type="primary"
                    >{{ $t("Add Comment") }}</a-button>
                  </a-form-item>
                </div>
              </a-comment>
            </template>
          </div>
          <invoiceHistory
            v-if="prew_history"
            :document="element"
            :fieldColumns="fieldColumns"
            :COMPANY_LIST="COMPANY_LIST"
            :MY_COMPANY_LIST="MY_COMPANY_LIST"
            :USER_LIST="USER_LIST"
            style="padding: 15px"
            @onBack="prew_history = false"
          />
        </template>
      </div>
    </a-spin>
    <div
      class="mainBlock--btn"
      v-show="!prew_history"
    >
      <a-row>
        <a-col :span="10">
          <a-button-group>
            <a-button @click="handleHistoryFile">
              <a-icon type="history" />
              {{ $t("History") }}
            </a-button>
            <a-button
              icon="eye"
              @click="preview"
            >{{ $t("Preview") }}</a-button>
            <a-button
              @click="myPrint"
              type="primary"
              icon="printer"
            >
              {{ $t("Print") }}
            </a-button>
            <a-button
              type="primary"
              :href="element.url"
              icon="download"
            >
              {{ $t("Download") }}
            </a-button>
          </a-button-group>
        </a-col>
        <a-col
          :span="6"
          style="text-align: center"
        >
          <div
            v-if="currentEdit"
            style="display: flex; align-items: center; justify-content: center"
          >
            <a-statistic-countdown
              :value="deadline"
              @finish="() => this.handlerBack({})"
              format="mm:ss"
              style="margin-right: 10px"
            />
            <a-tooltip
              :title="$t('Time until the end of the session')"
              style="margin-right: 50px"
            >
              <a-icon type="info-circle" />
            </a-tooltip>
          </div>
          <span v-else>{{
            $t("This file is edited by") +
            " " +
            getUser(element.currentlyeditor)
          }}</span>
        </a-col>
        <a-col
          :span="8"
          style="text-align: right"
        >
          <a-button
            v-if="profile.ADMIN && current < 6"
            @click="() => handleSubmitStep(false)"
            style="margin-right: 25px"
            icon="save"
          />
          <a-button-group style="margin-right: 25px">
            <a-button
              v-if="current > 0 && current < 6 && profile.ADMIN"
              @click="ReturnToStepBack"
              type="primary"
            >
              <a-icon type="left" />
              {{ current == 2 || current == 3 ? $t("Reject") : $t("Back") }}
            </a-button>
            <a-button
              @click="() => handleSubmitStep()"
              type="primary"
              :disabled="isSaveDisabled || disableFromResponsible"
              v-if="current <= 5"
            >
              {{ current == 2 || current == 3 ? $t("Akceptuj") : $t("Save") }}
              <a-icon type="right" />
            </a-button>
          </a-button-group>
          <a-button
            type="danger"
            icon="close"
            @click="() => showBackModalConfirm(true)"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import firstStep from "./invoices_steps/first";
import secondStep from "./invoices_steps/second";
import thirdStep from "./invoices_steps/third";
import fourthStep from "./invoices_steps/fourth";
import fifthStep from "./invoices_steps/fifth";
import sixthStep from "./invoices_steps/sixth";
import invoicePreview from "./invoicePreview";
import invoiceHistory from "./invoiceHistory.vue";
import {
  getHistory,
  uploadFile,
  deletePage,
  commentAdd,
  editClose,
  // findOCR,
  // extractTableOCR,
} from "@/requestFunc";
import printJS from "print-js";
import moment from "moment";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
//checkOn23Vat
import { findTable } from "@/findTable";

export default {
  props: [
    "element",
    "statusList",
    "navigation",
    "profile",
    "current",
    "form_info",
    "key_words",
    "disableFromResponsible",
    "responsible",
    "user_setup",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "previewElement",
    "fieldColumns",
  ],
  components: {
    firstStep,
    secondStep,
    thirdStep,
    fourthStep,
    fifthStep,
    sixthStep,
    invoicePreview,
    invoiceHistory,
  },
  data() {
    return {
      bounds: [],
      table: [],
      tablePDF: [],
      table_defaults: [],
      isSaveDisabled: false,
      DescInvoiceColumns: [
        {
          title: this.$t("Nazwa towaru/uslugi"),
          dataIndex: "namefield",
          scopedSlots: { customRender: "namefield" },
        },
        {
          title: this.$t("Cena"),
          dataIndex: "unitPrice",
          scopedSlots: { customRender: "unitPrice" },
        },
        {
          title: this.$t("Ilość"),
          dataIndex: "quantity",
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: this.$t("Wartosc netto"),
          dataIndex: "koszty",
          scopedSlots: { customRender: "koszty" },
        },
        {
          title: this.$t("Stawka VAT"),
          dataIndex: "vat",
          width: 150,
          scopedSlots: { customRender: "vat" },
        },
        {
          title: this.$t("Kwota VAT"),
          dataIndex: "vat2",
        },
        {
          title: this.$t("Wartosc z VAT"),
          dataIndex: "sum",
        },
        {
          title: this.$t("Op."),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      statusTag: {},
      DescInvoiceEditingKey: "",
      cacheData: [],
      currentPage: 1,
      countPages: 1,
      invoiceChanged: false,
      deadline: 0,
      currentEdit: false,
      submittingComment: false,
      visiblePreview: false,
      DeletePageloading: false,
      valueComment: "",
      newPages: [],
      spinning: false,
      addFileList: [],
      uploading: false,
      prew_doc_spinner: true,
      docPdf: true,
      keyLastIndex: 0,
      flagRename: false,
      prew_history: false,
      vat_options: {},
      prew_doc: false,
      Quota: {
        Netto: 0,
        Vat: 0,
        Bruto: 0,
      },
      stepList: [
        "REJESTRACJA",
        "OPISANIE FVK",
        "ROZKSIEKOWANE IN STEP",
        "BIURO KSIĘGOWE",
        "PŁATNOŚĆ",
        "ZAAKCEPTOWANE IN STEP",
      ],
    };
  },
  watch: {
    table() {
      let kk = [];
      for (let i in this.table_defaults) {
        let el = this.table_defaults[i];
        if (el.title && el.netto) {
          kk.push({
            key: i,
            namefield: el.title.replace("\n", " "),
            quantity: el.quantity,
            unitPrice: 0,
            koszty: el.netto,
            vat: el.vat_percent || "",
            vat2: el.netto_delta || "",
            sum: el.netto && el.netto_delta ? +el.netto + +el.netto_delta : "",
          });
        }
      }

      if (kk.length && !this.element.invoiceTable.length) {
        this.element.invoiceTable = kk;
        this.cacheData = this.element.invoiceTable.map((item) => ({ ...item }));
        this.updateQuota();
      }
    },
    tablePDF() {

      for (let i in this.tablePDF) {
        if (!this.element.invoiceTable[i]) this.handleAddDescInvoice();
        this.element.invoiceTable[i].namefield = this.tablePDF[i].name;
        this.element.invoiceTable[i].koszty = this.tablePDF[i].NETTO;
        this.element.invoiceTable[i].quantity = this.tablePDF[i].quantity;
        if (isNaN(parseInt(this.tablePDF[i].VAT.percent))) {
          this.element.invoiceTable[i].vat = this.vat_options[
            this.tablePDF[i].VAT.percent
          ];
        } else {
          this.element.invoiceTable[i].vat = this.tablePDF[i].VAT.percent + "%";
        }
      }
      if (this.element.invoiceTable.length) {
        let lastRecord = this.element.invoiceTable[
          this.element.invoiceTable.length - 1
        ];
        if (
          this.element.invoiceTable.length > 1 &&
          !lastRecord.koszty &&
          lastRecord.koszty == this.Quota.Bruto
        ) {
          this.cancelDescInvoice(lastRecord.key);
        } else {
          this.saveDescInvoice(lastRecord.key);
        }
      }
    },
  },
  computed: {
    title_options() {
      let options = this.table.flat().map((e) => e.replace("\n", " "));
      return options.filter((e, i) => e && options.indexOf(e) == i);
    },
    costs_options() {
      let options = this.table.flat().map((e) => e.replace(/[^\d.,]/g, ""));
      return options.filter((e, i) => e && options.indexOf(e) == i);
    },
    comments() {
      if (this.element.allcomments != undefined) {
        for (let item of this.element.allcomments) {
          //let user = this.element.userList[item.author];
          let user = this.element.userList.find((x) => x.ID == item.author);
          item["FIO"] = user.NAME + " " + user.LAST_NAME;
          item["photo"] =
            user.PERSONAL_PHOTO != null ? user.PERSONAL_PHOTO : "";
          item.like = JSON.parse(item.like);
          item.dislike = JSON.parse(item.dislike);
          item["likes"] = item.like.length;
          item["dislikes"] = item.dislike.length;
        }
        return this.element.allcomments;
      }
      return [];
    },
  },
  methods: {
    moment,
    showPreview(element) {
      this.visiblePreview = true;
      if (element) {
        this.previewElement = element;
      }
    },
    handleSubmitComment() {
      if (!this.valueComment) {
        return;
      }
      this.submittingComment = true;
      var comment = {
        FIO: this.profile.NAME + " " + this.profile.LAST_NAME,
        author: this.profile.ID,
        photo:
          this.profile.PERSONAL_PHOTO != null
            ? this.profile.PERSONAL_PHOTO
            : "",
        content: this.valueComment,
        likes: 0,
        like: ["23"],
        dislikes: 0,
        dislike: ["33"],
        datetime: moment().format("YYYY-MM-DD hh:mm:ss"),
      };
      this.comments.push(comment);
      this.valueComment = "";
      commentAdd([comment], this.element)
        .done((x) => {
          if (this.element.mainid == undefined) {
            let elem = JSON.parse(x);
            this.element = elem;
          }
          this.$message.success(this.$t("upload comment successfully."));
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("upload comment failed."));
        })
        .always(() => {
          this.submittingComment = false;

          BX24.fitWindow();
        });
    },
    handleChangeComment(e) {
      this.valueComment = e.target.value;
    },
    dislike() {
      this.likes = 0;
      this.dislikes = 1;
      this.action = "disliked";
    },
    myPrint() {
      printJS({
        printable:
          this.element.DOWNLOAD_URL == undefined
            ? this.element.url
            : this.element.DOWNLOAD_URL,
        type: "pdf",
        showModal: true,
      });
    },
    beforeUpload(file) {
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "filemerge");
      formData.append("ID", this.element.ID);
      formData.append("download_url", this.element.DOWNLOAD_URL);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });

      this.uploading = true;
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          for (
            let i = this.countPages + 1;
            i <= this.countPages + res.count_page;
            i++
          ) {
            this.newPages.push(i);
          }
          this.addFileList = [];
          this.uploading = false;
          this.currentPage = this.countPages + 1;
          this.getpdf();
          this.$message.success(this.$t("upload successfully."));
        })
        .fail((e) => {
          this.uploading = false;
          console.error(e);
          this.$message.error(this.$t("upload failed."));
        });
    },
    getUser(id) {
      let user = this.element.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : '';
    },
    showDeleteConfirm() {
      this.$confirm({
        title: this.$t("Are you sure you want to delete the current page?"),
        content: this.$t("Current page") + " - " + this.currentPage,
        okText: this.$t("Yes"),
        okType: "danger",
        cancelText: this.$t("No"),
        onOk: () => {
          this.DeletePageloading = true;
          deletePage(this.element.ID, this.currentPage)
            .done(() => {
              let index = this.newPages.indexOf(this.currentPage);
              this.newPages.splice(index, 1);
              for (let i = index; i < this.newPages.length; i++) {
                this.newPages[i]--;
              }
              this.currentPage--;
              this.countPages--;

              this.getpdf();
            })
            .fail((e) => console.error(e))
            .always(() => {
              this.DeletePageloading = false;
            });
        },
        onCancel() {},
      });
    },
    next() {
      this.currentPage++;
    },
    prev() {
      this.currentPage--;
    },
    ReturnToStepBack() {
      this.$emit("ReturnToStepBack");
    },
    async handlerBack(data) {
      await editClose(this.element.mainid);
      this.$emit("back", {
        visible_doc: true,
        unshift_elem: data.unshift_elem,
        remove_elem: data.remove_elem,
        updateStatus: data.updateStatus,
        updateStatistic: data.updateStatistic,
      });
      document.getElementById("maindivmenu").scrollIntoView();
    },
    preview() {
      this.$emit("preview", {
        file: this.element,
        page: this.currentPage,
      });
    },
    changeSpinning() {
      this.spinning = !this.spinning;
    },
    handleSubmitStep(updateStatus = true) {
      let steps = [
        "firstStep",
        "secondStep",
        "thirdStep",
        "fourthStep",
        "fifthStep",
        "sixthStep",
      ];
      this.$refs[steps[this.current]].submit(updateStatus);
    },
    handlerSaveDisabled(param) {
      this.isSaveDisabled = param.isSaveDisabled;
      this.invoiceChanged = param.invoiceChanged;
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },
    getpdf() {
      let pdfAsArray = this.Uint8ArrayFromBase64(this.element.base64file);
      // var url = this.element.DOWNLOAD_URL || this.element.url;
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      // var loadingTask = pdfjsLib.getDocument(url);
      var loadingTask = pdfjsLib.getDocument(pdfAsArray);
      loadingTask.promise.then(
        (pdf) => {
          try {
            this.countPages = pdf.numPages;
            if (1 <= this.currentPage && this.countPages >= this.currentPage) {
              pdf.getPage(this.currentPage).then((page) => {
                var canvas = document.getElementById("pdf-canvas-step");

                let realW = $("#pdf-canvas-step").width();
                var viewport = page.getViewport({
                  scale: realW / page.getViewport({ scale: 1.0 }).width,
                });
                var context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                page
                  .render(renderContext)
                  .promise.then(() => {
                    canvas.style.display = "unset";
                    if (this.current == 0) {
                      page.getTextContent().then((textContent) => {
                   
                        if (textContent.items.length) {
                          // let titles = textContent.items.map((x) => x.str);
                          let text = "";
                          let prev = {
                            x: 0,
                            y: 0,
                          };
                          for (let item of textContent.items) {
                            if (
                              prev.x + 1 >= item.transform[4] &&
                              prev.x - 1 <= item.transform[4] &&
                              prev.y + 1 >= item.transform[5] &&
                              prev.y - 1 <= item.transform[5]
                            ) {
                              text += item.str;
                            } else {
                              text += ` ${item.str}`;
                            }
                            prev.x = item.transform[4] + item.width;
                            prev.y = item.transform[5];
                          }
                          this.bounds = [
                            {
                              label: "whole",
                              text: text,
                              titles: textContent.items.map((x) => x.str),
                            },
                          ];
                          if (!this.element.invoiceTable.length)
                            this.tablePDF = findTable(textContent);
                          this.prew_doc_spinner = false;
                        } else {
                          // let img = canvas.toDataURL("img/jpeg", 1);
                          // this.prew_doc_spinner = true;
                          // findOCR(img, this.user_setup.api_ocr_token, url)
                          //   .done((res, state) => {
                          //     if (state == "success") {
                          //       this.bounds = res.bounds;
                              
                          //     }
                          //     let table = this.bounds.find(
                          //       (el) => el.label == "table"
                          //     );
                          //     if (table && this.tablePDF.length == 0) {
                          //       extractTableOCR({
                          //         imgBase64: img,
                          //         bounds: table.bounds_corr,
                          //         token: this.user_setup.api_ocr_token,
                          //         pdf: url,
                          //       }).then((table_data) => {
                          //         this.table_defaults = table_data.defaults;
                          //         this.table = table_data.table;
                                 
                          //       });
                          //     }
                          //   })
                          //   .catch(()=>{})
                          //   .always(() => {
                          //     this.prew_doc_spinner = false;
                          //   });
                        }

      this.prew_doc_spinner = false;

                      });
                    } else {
                      this.prew_doc_spinner = false;
                    }

                    BX24.fitWindow();
                    return page.getTextContent();
                  })
                  .then(function (textContent) {
                    var pdf_canvas = $("#pdf-canvas-step");

                    var canvas_height = pdf_canvas.get(0).height;
                    var canvas_width = pdf_canvas.get(0).width;

                    $("#text-layer-step").css({
                      // left: canvas_offset.left + "px",
                      // top: canvas_offset.top + "px",
                      left: "2px",
                      top: "2px",
                      height: canvas_height + "px",
                      width: canvas_width + "px",
                    });
                    pdfjsLib.renderTextLayer({
                      textContent: textContent,

                      container: $("#text-layer-step").get(0),
                      viewport,
                      textDivs: [],
                    });
                  });
              });
            }
          } catch {
            this.prew_doc = true;
            this.prew_doc_spinner = false;
          }
        },
        () => {
          this.prew_doc = true;
          this.prew_doc_spinner = false;
        }
      );
    },
    handleHistoryFile() {
      this.changeSpinning();
      let doc_id =
        this.element.mainid != undefined
          ? this.element.mainid
          : this.element.mainid;
      getHistory(doc_id).done((x) => {
        this.changeSpinning();
        this.element.HISTORY = x ? JSON.parse(x) : {};

        this.prew_history = !this.prew_history;
      });
    },
    resize() {
      setTimeout(
        () =>
          BX24.resizeWindow(
            parseInt($("body #root_block").css("width")),
            parseInt($("body #root_block").css("height"))
          ),
        100
      );
    },
    handleChangeDescInvoice(value, key, column) {
      const newData = [...this.element.invoiceTable];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        this.invoiceChanged = true;
        target[column] = value;
        this.element.invoiceTable = newData;
      }
    },
    editDescInvoice(key) {
      const newData = [...this.element.invoiceTable];
      const target = newData.filter((item) => key === item.key)[0];
      this.DescInvoiceEditingKey = key;
      if (target) {
        target.editable = true;
        this.element.invoiceTable = newData;
      }
    },
    saveDescInvoice(key) {
      const newData = [...this.element.invoiceTable];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        // let kk = this.form_info.VAT.find((x) => x.NAME == );
        let vat = this.vat_options[target.vat];
        target.unitPrice = typeof target.unitPrice == "string"
            ? parseFloat(target.unitPrice.replace(",", "."))
            : target.unitPrice;
        let koszty =
          typeof target.unitPrice == "string"
            ? parseFloat(target.unitPrice.replace(",", ".")) * target.quantity
            : target.unitPrice * target.quantity;
        target.koszty = isNaN(koszty) ? 0 : koszty.toFixed(2);
        target.vat2 = Math.round((
          +target.unitPrice *
          +target.quantity *
          (+vat / 100)
        )*100)/100; 
        target.sum = (+target.unitPrice * +target.quantity + +target.vat2).toFixed(
          2
        );
        this.element.invoiceTable = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        this.updateQuota();
      }
      this.DescInvoiceEditingKey = "";
    },
    handleAddDescInvoice() {
      for (let i in this.element.invoiceTable) {
        if (this.element.invoiceTable[i]["editable"]) {
          if (
            this.element.invoiceTable[i].namefield &&
            this.element.invoiceTable[i].koszty
          ) {
            this.saveDescInvoice(this.element.invoiceTable[i].key);
            break;
          } else {
            return;
          }
        }
      }
      const newData = {
        key: this.keyLastIndex,
        namefield: "",
        quantity: 1,
        vat: "",
        koszty: "",
        unitPrice: 0,
        vat2: "",
        sum: "",
        editable: true,
      };
      this.DescInvoiceEditingKey = newData.key;
      this.element.invoiceTable = [...this.element.invoiceTable, newData];
      this.cacheData = this.element.invoiceTable.map((item) => ({ ...item }));
      this.keyLastIndex++;
      BX24.fitWindow();
    },
    cancelDescInvoice(key) {
      const newData = [...this.element.invoiceTable];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCach = this.cacheData.filter((item) => key === item.key)[0];
      this.DescInvoiceEditingKey = "";
      if (target && targetCach.namefield && targetCach.koszty) {
        Object.assign(target, targetCach);
        delete target.editable;
        this.element.invoiceTable = newData;
      } else {
        this.onDeleteDescInvoice(key);
      }
    },
    onDeleteDescInvoice(key) {
      const dataSource = [...this.element.invoiceTable];
      this.element.invoiceTable = dataSource.filter((item) => item.key !== key);
      this.cacheData = this.element.invoiceTable.map((item) => ({ ...item }));
      this.updateQuota();
      this.resize();
    },
    updateQuota() {
      this.Quota.Netto = this.Quota.Vat = this.Quota.Bruto = 0;
      for (let i in this.element.invoiceTable) {
        this.Quota.Netto +=
          +this.element.invoiceTable[i].unitPrice *
          +this.element.invoiceTable[i].quantity;
        this.Quota.Vat += +this.element.invoiceTable[i].vat2;
        this.Quota.Bruto += +this.element.invoiceTable[i].sum;
      }
      this.element.Quota = this.Quota;
      this.$refs.firstStep.updateKwota();
    },
    async showBackModalConfirm(centered = false) {
      let checkChanged = false;
      if (this.profile.ADMIN && this.current < 5) {
        let steps = [
          "firstStep",
          "secondStep",
          "thirdStep",
          "fourthStep",
          "fifthStep",
        ];
        checkChanged = this.$refs[steps[this.current]].checkChanged();
      } else {
        if (this.current == 0) {
          checkChanged = this.$refs.firstStep.checkChanged();
        } else if (this.current == 2) {
          checkChanged = this.$refs.secondStep.checkChangedVal;
        }
      }
      if (
        (checkChanged || this.invoiceChanged) &&
        !this.disableFromResponsible
      ) {
        this.$confirm({
          title: this.$t("Save changes?"),
          centered,
          okText: this.$t("Yes"),
          okType: "danger",
          okButtonProps: {
            props: { type: "primary" },
          },
          cancelText: this.$t("No"),
          onOk: () => {
            this.handleSubmitStep(false);
          },
          onCancel: () => {
            this.handlerBack({});
          },
        });
      } else {
        this.handlerBack({});
      }
    },
    getMimeFromUint8Array(uint8Array) {
      const header = Array.from(uint8Array.slice(0, 4))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
      switch (header) {
        case "25504446":
          return "application/pdf"; // %PDF
        case "89504e47":
          return "image/png"; // PNG
        case "ffd8ffe0": // fallthrough
        case "ffd8ffe1":
        case "ffd8ffe2":
          return "image/jpeg"; // JPG
        default:
          return "unknown";
      }
    },
  },
  mounted() {
    this.vat_options = Object.fromEntries(
      this.form_info.VAT.map((e) => [e["NAME"], e["RATE"]])
    );
    if (this.current == 0) this.updateQuota();
    if (this.current != 0) {
      this.DescInvoiceColumns.pop();
    }
    this.statusTag = this.statusList.find((x) => x.name == this.element.status);

    let pdfAsArray = this.Uint8ArrayFromBase64(this.element.base64file);
    const mimeType = this.getMimeFromUint8Array(pdfAsArray);
    // console.log("invoices_steps 📂 Detected MIME type:", mimeType);

    // if (
    //   this.element.NAME.indexOf(".jpg") != -1 ||
    //   this.element.NAME.indexOf(".png") != -1
    // ) {
      if (mimeType === "image/png" || mimeType === "image/jpeg") {
      this.docPdf = false;
      this.prew_doc_spinner = false;
    } else {
      if (this.current != 1) {
        this.getpdf();
      }
    }
    if (this.profile.ID == this.element.currentlyeditor || !this.element?.currentlyeditor) {
      this.currentEdit = true;
    }
    this.deadline = Date.now() + 1000 * 600;
    if (Array.isArray(this.element.invoiceTable)) {
      this.cacheData = this.element.invoiceTable.map((item) => ({ ...item }));
    } else {
      this.element.invoiceTable = [];
      this.cacheData = [];
    }
    this.resize();
  },
};
</script>

<style scoped>
.appBlock {
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
}

.appBlock .title {
  font-size: 24px;
}

.steps {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.steps > div:first-child {
  width: 100%;
  padding: 15px 0px;
}

.steps > div:last-child {
  align-self: center;
}

.mainBlock--form > div:first-child {
  display: flex;
}

.mainBlock--btn {
  margin-top: 20px;
}

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
#my_comments_styl .ant-list-item {
  padding: 0;
}
</style>
